// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"21ed976f6d4fb50e","3713":"1b5122098e30ec49","8288":"3af1a6bffe64da40","8686":"1b05aa83d3558204"}[chunkId] + ".css";
};